import _ from 'lodash';
import formatDate from './formatDate';

export default function mapCarrierServiceWithRates(rateResults) {
	const options = [];
	_.each(rateResults, rateResult => {
		_.each(rateResult.rates, rate => {
			let carrierName = rate.isLtl ? rate.priority1CarrierName : _.get(rate, 'carrier.name');
			// ShipStation rates are carrier-less (only a service + price); show no carrier suffix.
			let label = rate.isShipStation
				? `${rate.carrierService.name} - $${rate.total}`
				: `${rate.carrierService.name} - $${rate.total} ${' - ' + carrierName}`;
			let optionItem = {
				value: rate.carrierService.id,
				label: label,
				extra: {
					rate: rate.value,
					carrier: rate.carrier,
					rateComposition: {
						total: rate.total,
						cost: rate.value,
						surcharge: rate.accountSurcharge,
					},
					deliveryTimestamp: rate.deliveryTimestamp ? formatDate(rate.deliveryTimestamp, false, 'L') : '',
					includedBenefits: rate.includedBenefits,
					excludedBenefits: rate.excludedBenefits,
					rateId: rate.rateId,
					rateMatchKey: rate.rateMatchKey,
					isLtl: rate.isLtl,
					isShipStation: rate.isShipStation
				},
			};
			options.push(optionItem);
		});
	});
	// Cheapest first.
	return _.sortBy(options, o => o.extra.rateComposition.total);
}
